<template>
  <div class="mx-auto auth-page-container">
    <b-card class="auth-card" no-body>
      <div class="form-side">
        <main-logo />
        <b-form @submit.prevent="formSubmit" class="av-tooltip tooltip-label-bottom">
          <b-form-group :label="$t('anyform.username')" class="mb-4">
            <b-form-input type="text" v-model="$v.form.username.$model" :state="!$v.form.username.$error" />
            <b-form-invalid-feedback v-if="!$v.form.username.required"
              >Please enter your email address</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group :label="$t('anyform.password')" class="mb-4">
            <b-form-input type="password" v-model="$v.form.password.$model" :state="!$v.form.password.$error" />
            <b-form-invalid-feedback v-if="!$v.form.password.required"
              >Please enter your password</b-form-invalid-feedback
            >
          </b-form-group>
          <div class="d-flex justify-content-between align-items-center">
            <b-button
              type="submit"
              variant="primary"
              size="lg"
              :disabled="processing"
              :class="{
                'btn-multiple-state btn-shadow': true,
                'show-spinner': processing,
                'show-success': !processing && loginError === false,
                'show-fail': !processing && loginError
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="icon success">
                <i class="simple-icon-check"></i>
              </span>
              <span class="icon fail">
                <i class="simple-icon-exclamation"></i>
              </span>
              <span class="label text-uppercase">{{ $t('buttons.login') }}</span>
            </b-button>
          </div>
        </b-form>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MainLogo from '@/components/Common/MainLogo'
const { required } = require('vuelidate/lib/validators')

export default {
  components: { MainLogo },
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  validations: {
    form: {
      username: { required },
      password: { required }
    }
  },
  computed: {
    ...mapGetters({
      processing: 'auth/processing',
      loginError: 'auth/loginError'
    })
  },
  methods: {
    formSubmit() {
      this.$v.$touch()
      if (!this.$v.form.$anyError) {
        const payload = {
          name: this.form.username,
          password: this.form.password
        }

        this.$store.dispatch('auth/login', { payload, vm: this })
      }
    }
  },
  watch: {
    loginError(val) {
      if (val != null) {
        this.$notify('error', 'Login Error', val, {
          duration: 3000,
          permanent: false
        })
      }
    }
  }
}
</script>
